import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n/config'
import './styles/index.css'
import { hydrateTokensFromCookies, restoreDurableTokens } from '@/utils/tokenStorage'
import { restorePasskeyFlag } from '@/utils/deviceUnlock'
import { isStandaloneDisplay } from '@/utils/pwaDisplay'

async function leaveIpForFaceId(): Promise<void> {
  if (location.pathname.startsWith('/dev/')) return
  if (!/^\d{1,3}(\.\d{1,3}){3}$/.test(location.hostname)) return
  try {
    const res = await fetch('/dev-faceid-host')
    if (!res.ok) return
    const data = await res.json() as { host?: string; port?: number }
    if (!data.host) return
    const port = data.port || 5173
    location.replace(`https://${data.host}:${port}${location.pathname}${location.search}${location.hash}`)
    await new Promise(() => {})
  } catch {
    /* production has no dev host */
  }
}

async function boot() {
  await leaveIpForFaceId()
  await restoreDurableTokens()
  hydrateTokensFromCookies()
  await restorePasskeyFlag()
  if (isStandaloneDisplay()) {
    void navigator.storage?.persist?.().catch(() => {})
  }
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

void boot()

if (
  'serviceWorker' in navigator &&
  (import.meta.env.PROD || import.meta.env.VITE_PWA_DEV === '1')
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .catch(() => {})
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      refreshing = true
      location.reload()
    })
  })
}
